import { useRef, useCallback, useMemo } from "react";
import { bindActionCreators } from "redux";
import { useDispatch } from "react-redux";
import { wrapPromise } from "../../../utils/promise";
import { removeParcelsActionCreators } from "../../../store/actions/ui/routeDetail/removeParcels";

export default () => {
  const removeParcelsModalRef = useRef();
  const dispatch = useDispatch();

  const { onMove, getAffectedStops } = useMemo(
    () => bindActionCreators(removeParcelsActionCreators, dispatch),
    [dispatch]
  );

  const openRemoveParcelsModal = useCallback(() => {
    return wrapPromise(
      removeParcelsModalRef.current.showModal({ onMove, getAffectedStops })
    );
  }, [onMove, getAffectedStops]);

  return {
    removeParcelsModalRef,
    openRemoveParcelsModal,
  };
};
